var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10V19H19V10C19 6.12281 15.8772 3 12 3C8.12281 3 5 6.12281 5 10ZM20 17H18C17.4561 17 17 17.4561 17 18C17 18.5439 17.4561 19 18 19H20C20.5439 19 21 18.5439 21 18C21 17.4561 20.5439 17 20 17ZM4 19H6C6.54386 19 7 18.5439 7 18C7 17.4561 6.54386 17 6 17H4C3.45614 17 3 17.4561 3 18C3 18.5439 3.45614 19 4 19ZM12 21C12 20.4561 11.5439 20 11 20C10.4561 20 10 20.4561 10 21C10 22.1053 10.8947 23 12 23C13.1053 23 14 22.1053 14 21C14 20.4561 13.5439 20 13 20C12.4561 20 12 20.4561 12 21ZM10 4V5.26316C11.4561 5.03509 11.7193 5 12 5C12.2807 5 12.5439 5.03509 14 5.26316V4C14 2.89474 13.1053 2 12 2C10.8947 2 10 2.89474 10 4ZM11 22H13C13.5439 22 14 21.5439 14 21C14 20.4561 13.5439 20 13 20H11C10.4561 20 10 20.4561 10 21C10 21.5439 10.4561 22 11 22ZM13 21H11C11 21.5439 11.4561 22 12 22C12.5439 22 13 21.5439 13 21Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.22c21a35.svg";
export { ForwardRef as ReactComponent };